module.exports = __webpack_public_path__ + "static/media/OW1.06df1870.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW1.png
// module id = 716
// module chunks = 0